<template>
    <div class="flex flex-wrap gap-5 mt-6">
        <table-filters
            :filters="appliedFilters"
            :allowed-filters="remainingAllowedFilters"
            :applied-filters="appliedFilterConfigs"
            @filter-applied="onFilterApplied"
            @filter-removed="onFilterRemoved"
        />
    </div>
    
    <slot />
</template>

<script setup>
import { computed, onMounted } from 'vue';
import TableFilters from '@/system/components/global/table/TableFilters.vue';
import { useJournalsStore } from '@/system/stores/useJournalsStore';

const emit = defineEmits(['filters-changed']);
const store = useJournalsStore();

onMounted(async () => {
    await store.loadAllowedFilters();
});

const appliedFilterConfigs = computed(() => store.appliedFilterConfigs);
const remainingAllowedFilters = computed(() => store.allowedFilters);
const appliedFilters = computed(() => store.filters);

function onFilterApplied(filter) {
    store.setFilter(filter);
    emit('filters-changed', store.filters);
}

function onFilterRemoved(fieldKey) {
    store.removeFilter(fieldKey);
    emit('filters-changed', store.filters);
}
</script>
